import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IAddRequirementType } from "./Table";

interface IProps{
    singleData: IAddRequirementType,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    reqType: yup.string().required("Requirement Type field is required"),
    description: yup.string(),
});

export const Form = (props: IProps) => {
    const [saveDis,setSaveDis] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IAddRequirementType>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit=(data: IAddRequirementType)=>{
        setSaveDis(true);
        saveToDB(data);
    }

    const saveToDB = async (data: IAddRequirementType) => {
        const method = props.singleData.reqType != "" ? "PUT" : "POST";
        const message = props.singleData.reqType !="" ? "Updated Successfully" : "Added Successfully";

        console.log(method,message);

        const response = await Fetch("RequirementType_Mast", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onHide=()=>{
        props.hideDialog();
    }

    useEffect(()=>{
        reset(props.singleData);
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Add Requirement Type" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Requirement Type:" control={control} name="reqType" error={errors.reqType?.message} />
                <JVInput label="Description:" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}